// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5b3b916e","239":"e4e78018","453":"f80d1ed6","732":"5feab66c"}[chunkId] + ".chunk.js";
};